import { 
    apiRequest,
    perjalananDinasCreate,
    masterSignatories
} from '../../../../../../services/adapters/kepegawaian/perjalananDinasService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", perjalananDinasCreate, {
            body: query
        }, true)
    }

    fetchSignatories = async (query) => {
        return await apiRequest("get", masterSignatories, {
            params: query
        }, true)
    }

}

export default CreateRepository